@if (isStaffDoor) {
  <app-auth-layout
    art="door"
    headline="The platform built for field teams."
    blurb="Browse every customer organization, review sign-in activity and view the portal as
           any customer sees it."
    [tags]="['Organizations', 'View as', 'Audit']"
  >
    <img class="door__logo" src="/assets/brand/davaco.svg" alt="Davaco" />

    <p class="door__provider">
      <app-microsoft-mark [size]="18" />
      Microsoft Identity · Davaco staff only
    </p>

    @if (!failed()) {
      <h2 class="door__title">Welcome back</h2>
      <p class="door__sub">Sign in to your Davaco account to continue.</p>
    } @else {
      <h2 class="door__title">We couldn't reach sign-in</h2>
      <p class="door__sub">
        Something went wrong on the way to Microsoft. This is usually temporary.
      </p>
    }

    <button type="button" class="door__button" [disabled]="pending()" (click)="redirect()">
      <app-microsoft-mark [size]="18" />
      {{ failed() ? 'Try again' : 'Continue with Microsoft' }}
    </button>

    <div class="door__rule"></div>

    <p class="door__link"><span>No account?</span><span>Contact IT</span></p>
    <p class="door__link"><span>Can't access your account?</span><span>Get help</span></p>
  </app-auth-layout>
} @else {
  <!-- Customer subdomain: the interstitial, not a door. See the component. -->
  <div class="interstitial">
    <app-brand-logo
      class="interstitial__logo"
      [src]="branding().logoUrl"
      [name]="branding().displayName"
    />

    @if (!failed()) {
      <div class="interstitial__spinner" aria-hidden="true"></div>
      <p class="interstitial__message">Taking you to secure sign-in…</p>
      <p class="interstitial__hint">{{ branding().displayName }} · Davaco Customer Portal</p>
    } @else {
      <h1 class="interstitial__title">We couldn't reach sign-in</h1>
      <p class="interstitial__message">
        Something went wrong on the way to the secure sign-in page. This is usually temporary.
      </p>
      <button type="button" class="interstitial__retry" (click)="redirect()">Try again</button>
    }
  </div>
}
